import { ScrollTrigger } from "gsap/ScrollTrigger";
import { $ } from "./recruit-utils.js";

/**
 * Recruit Animation - Header Control (Original Version)
 * ヘッダースタイル制御（元版）
 */

export function initHeaderStyleControl() {
  const header = $('.l-header--recruitment');
  const layout = $('.p-recruit-layout');
  const logoImg = $('.l-header__logo img');
  
  if (!header || !layout || !logoImg) return;
  
  // ヘッダーの高さを動的に取得
  const headerHeight = header.offsetHeight || 80;
  
  ScrollTrigger.create({
    trigger: layout,
    start: `top ${headerHeight}px`,
    
    onEnter: () => {
      // hero-animatingクラスがない場合のみスタイル変更
      if (!document.body.classList.contains('hero-animating')) {
        header.classList.add('is-white-bg');
        logoImg.src = logoImg.src.replace('logo_white.svg', 'logo.svg');
      }
    },
    
    onEnterBack: () => {
      if (!document.body.classList.contains('hero-animating')) {
        header.classList.add('is-white-bg');
        logoImg.src = logoImg.src.replace('logo_white.svg', 'logo.svg');
      }
    },
    
    onLeaveBack: () => {
      if (!document.body.classList.contains('hero-animating')) {
        header.classList.remove('is-white-bg');
        logoImg.src = logoImg.src.replace('logo.svg', 'logo_white.svg');
      }
    }
  });
}